export const WHATSAPP_NUMBER = "5511990277456";
export const WHATSAPP_DISPLAY = "(11) 99027-7456";

export const DEFAULT_MESSAGE =
  "Olá, Sabrina! Encontrei o seu site e gostaria de informações sobre atendimento.";

export const waLink = (message = DEFAULT_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const waTopic = (topic) =>
  waLink(
    `Olá, Sabrina! Encontrei o seu site e gostaria de conversar sobre ${topic}.`
  );

export const INSTAGRAM_URL = "https://www.instagram.com/sabrinamota.psi";

export const formatPrice = (v) =>
  v == null ? null : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const MODALITY_LONG = {
  online: "Online (videochamada)",
  presencial: "Presencial — Taboão da Serra, SP",
};

export const buildBookingWhatsAppMessage = (b) => {
  const dataCurta = new Date(`${b.date}T12:00:00`).toLocaleDateString("pt-BR");
  return (
    `Olá, Sabrina! Gostaria de agendar um atendimento.\n\n` +
    `Nome: ${b.name}\n` +
    `WhatsApp: ${b.whatsapp}\n` +
    `E-mail: ${b.email}\n\n` +
    `Atendimento: ${b.service_title}\n` +
    `Modalidade: ${MODALITY_LONG[b.modality]}\n` +
    `Data escolhida: ${dataCurta}\n` +
    `Horário escolhido: ${b.time}\n` +
    (b.protocol ? `Protocolo: ${b.protocol}\n` : "") +
    `\nGostaria de confirmar a disponibilidade e receber as informações sobre o valor e pagamento.`
  );
};

export const PROFESSIONAL = {
  brand: "Sabrina Mota — Psicologia e Neuropsicologia",
  name: "Sabrina Mota",
  fullName: "Sabrina Kettyllin Mariano Gaia Mota",
  titles: "Psicóloga | Neuropsicóloga",
  crp: "CRP 06/201923",
};

export const slugify = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const NAV_LINKS = [
  { to: "/", label: "Início", testId: "nav-inicio" },
  { to: "/sobre", label: "Sobre", testId: "nav-sobre" },
  { to: "/psicoterapia", label: "Psicoterapia", testId: "nav-psicoterapia" },
  { to: "/neuropsicologia", label: "Neuropsicologia", testId: "nav-neuropsicologia" },
  { to: "/conteudos", label: "Conteúdos", testId: "nav-conteudos" },
  { to: "/por-onde-comecar", label: "Por onde começar?", testId: "nav-por-onde-comecar" },
  { to: "/contato", label: "Contato", testId: "nav-contato" },
];
